module.exports = __webpack_public_path__ + "media/images/weather/201_night-0049bcee222ab8293c377ee77d0f1a9a.png";